<template>
    <div>
        <!-- <div class="row justify-content-center">
                <div class="col-12 col-ms-12 col-md-12 col-lg-12">
                    <div class="col-12 col-ms-12 col-md-12 col-lg-12 form-group">
                        <label>Fecha Real de Cobro *</label>
                            <v-date-picker
                            v-if="ctaporcobrar.Estatus=='NO'"
                            v-model="ctaporcobrar.FechaRealCobro"
                            :popover="{ 
                                placement: 'right',
                                visibility: 'click',
                                
                            }"
                        
                            :input-props='{
                                class:"form-control calendar",
                                style:"cursor:pointer;background-color:#F9F9F9",
                                readonly: true
                            
                            }'
                        /> 
                        <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.FechaRealCobro" :Mensaje="errorvalidacion.FechaRealCobro[0]"></Cvalidation></label>
                        <input v-if="ctaporcobrar.Estatus=='SI'" class="form-control" readonly v-model="FechaRealCobro">
                        
                        <br>
                        <label>No. Contrato</label>
                        <input readonly v-model="NumContrato" class="form-control" />
                        <br>
                        <label>Observaciones *</label>
                        <div v-if="ctaporcobrar.Estatus=='NO'">
                            <textarea v-model="ctaporcobrar.Observacion"  v-if="ctaporcobrar.Estatus=='NO'" placeholder=" Coloque sus Observaciones" class="form-control" cols="2" rows="3"></textarea>
                            <Cvalidation v-if="this.errorvalidacion.Observacion" :Mensaje="'Campo obligatorio'"></Cvalidation>
                        </div>
                        
                        <textarea v-model="ctaporcobrar.Observacion" v-if="ctaporcobrar.Estatus=='SI'" readonly placeholder="Coloque sus Observaciones" class="form-control" cols="2" rows="3"></textarea>
                        
                    </div>
                    
                </div>
        </div> -->
        <!--<pre>{{
            ctaporcobrar
            }}</pre>-->
		<div class="form-group row">
			<div class="col-lg-4">
				<label for="">Factura</label>
				<input type="text" class="form-control" readonly v-model="ctaporcobrar.Factura">
			</div>
			<div class="col-lg-4">
				<label for="">Monto Total</label>
				<vue-numeric :disabled="true" class="form-control " currency="$" separator="," :precision="2" v-model="ctaporcobrar.MontoTotal" placeholder="$0.00"></vue-numeric>
			</div>
			<div class="col-lg-4">
				<label for="">No. Contrato</label>
				<input type="text" class="form-control" readonly v-model="NumContrato">
			</div>
		</div>
		<div class="form-group row mt-3">
			<div class="col-lg-4">
				<label for="">Tipo Cobro</label>
				<select disabled v-model="ctaporcobrar.TipoCobro" class="form-control">
					<option value="1">Total</option>
					<option value="2">Parcial</option>
				</select>
			</div>
			<!-- <div class="col-lg-4">
				<label for="">Monto</label>
				<vue-numeric :disabled="true" @input="ChangeRestante" class="form-control " currency="$" separator="," :precision="2" v-model="ctaporcobrar.Monto" placeholder="$0.00"></vue-numeric>
			</div>
			<div class="col-lg-4">
				<label for="">Pendiente Pago</label>
				<vue-numeric :disabled="true" class="form-control " currency="$" separator="," :precision="2" v-model="ctaporcobrar.Restante" placeholder="$0.00"></vue-numeric>
			</div> -->
		</div>
		<div class="form-group row mt-3">
			<div v-for="(item,index) in ctaporcobrar.Pagos" :key="index" class="col-lg-3">
				<label for="">{{'Pago '+(index+1)}}</label>
				<v-date-picker
						v-model="item.Fecha"
						:popover="{
							placement: 'bottom',
							visibility: 'click'
						}"
						:input-props="{
							class: 'form-control calendar',
							style: 'cursor:pointer;',
							disabled: true
						}"
						:locale="'es-MX'"
					/>
			</div>
		</div>
		<div class="form-group row mt-3">
			<div class="col-lg-12">
				<label>Observaciones y Pagos Parciales *</label>
				<textarea readonly v-model="ctaporcobrar.Observacion" placeholder=" Coloque sus Observaciones" class="form-control" cols="2" rows="3"></textarea>
			</div>
		</div>
	</div>
</template>

<script>
import Cbtnsave from '@/components/Cbtnsave.vue'
import Cvalidation from '@/components/Cvalidation.vue'

export default {
   name:'cuentasporcobrar',
    props:['poBtnSave'],
     components:{
        
        Cbtnsave,Cvalidation
    },
    data() {
        return {
            
            ListaFacturas:[],
            cobrar:{},
            ctaporcobrar:{
                
                IdCtaCobrar:0,
                IdFactura:0,
                IdServicio:0,
                NumContrato:'',
                Archivo:'',
                Estatus:'',
                FechaRealCobro:'',
				Factura:'',
				TipoCobro:'1',
				MontoTotal:'',
				Monto:'',
				Restante:'',
				Pagos:[
					{Fecha:'',Monto:''},
					{Fecha:'',Monto:''},
					{Fecha:'',Monto:''},
					{Fecha:'',Monto:''}
				]
            },
            //IdContrato:0,
            NumContrato:'',
            FechaRealCobro:'',
            errorvalidacion:[],
			IndexFecha:0,
			RestanteOriginal:0
        }
    },
   
   methods: {
      
        Cobrado()
        { 
			let formData=new FormData();
			formData.set('IdCtaCobrar',this.ctaporcobrar.IdCtaCobrar);
			formData.set('TipoCobro',this.ctaporcobrar.TipoCobro);
			formData.set('Observacion',this.ctaporcobrar.Observacion);
			formData.set('Fecha',this.ctaporcobrar.Pagos[this.IndexFecha].Fecha.toISOString());
			formData.set('Monto',this.ctaporcobrar.Monto);
			formData.set('Restante',this.ctaporcobrar.Restante);
            this.poBtnSave.$toast=0;
            this.poBtnSave.disableBtn=true;
                this.$http.post(
                'ctaporcobrar/changeestatus',
                formData
            ).then( (res) => {
                this.poBtnSave.disableBtn=false;
                this.poBtnSave.toast=1;
                $('#UploadObservacion').modal('hide');
                this.bus.$emit('List');
                //this.$toast.success('Información Actualizada');
            }).catch( err => {
                //this.$toast.error('La infromación no pudo actualizarse');
                this.errorvalidacion=err.response.data.message.errores;
                this.poBtnSave.disableBtn=false;
                this.poBtnSave.toast=2;
            });
               
        },
		ChangeRestante(){
			this.ctaporcobrar.Restante=parseFloat(this.RestanteOriginal)-parseFloat(this.ctaporcobrar.Monto);
		},
       
        
        get_one()
        {
          
            this.$http.get(
               "ctaporcobrar/recovery",
                {
                    params:{IdCtaCobrar: this.ctaporcobrar.IdCtaCobrar}
                }
            ).then( (res) => {
            
            this.ctaporcobrar=res.data.data.ctaporcobrar;
            //console.log(this.ctaporcobrar);
                if(this.ctaporcobrar.Estatus=='SI'){
                    this.bus.$off('Save',()=>
                    {
                        //this.Cobrado();
                    });
            }else if(this.ctaporcobrar.Estatus=='NO'){
                this.bus.$on('Save',()=>
                {
                    
                    this.Cobrado();
                });
            }
           /*
            this.ctaporpagar.FechaFactura = new Date(dos);
            */
            });
        },

		Recuperar(){
			this.$http.get('ctaporcobrarpago/recovery',{
				params:{
					IdCtaCobrar:this.ctaporcobrar.IdCtaCobrar
				}
			}).then((res) => {
				let Pagado=0;
				let Pagos=res.data.data.pagos;
				if (Pagos.length>0) {
					this.IndexFecha=Pagos.length;
					for (let i = 0; i < Pagos.length; i++) {
						let FechaFormato=Pagos[i].Fecha.replace(/-/g, "\/");
						this.ctaporcobrar.Pagos[i].Fecha=new Date(FechaFormato);
						Pagado+=parseFloat(Pagos[i].Monto);
					}
				}
				else{
					Pagos[0].Fecha=res.data.data.ctaporcobrar.FechaRealCobro;
				}
				this.RestanteOriginal=Number(this.ctaporcobrar.MontoTotal)-Pagado;
				this.ctaporcobrar.Restante=Number(this.ctaporcobrar.MontoTotal)-Pagado;
			})
		},

    	Limpiar(){
			this.ctaporcobrar={
				IdCtaCobrar:0,
        	    IdFactura:0,
        	    IdServicio:0,
        	    NumContrato:'',
        	    Archivo:'',
        	    Estatus:'',
        	    FechaRealCobro:'',
				Factura:'',
				TipoCobro:'1',
				MontoTotal:'',
				Monto:'',
				Restante:'',
				Pagos:[
					{Fecha:'',Monto:''},
					{Fecha:'',Monto:''},
					{Fecha:'',Monto:''},
					{Fecha:'',Monto:''}
				]
			}
			this.IndexFecha=0;
        	this.errorvalidacion=[];

    	}
       
   	},

    created() {

       

      this.bus.$off('ParcialInfo');
      this.bus.$on('ParcialInfo',(Id, IdServ, NumContra,FechaRealCobro,IdFactura,Factura,Monto,Observacion,TipoCobro)=> 
      {
        this.Limpiar();
        this.ctaporcobrar.IdServicio=IdServ;
		this.ctaporcobrar.Factura=Factura;
		this.ctaporcobrar.MontoTotal=Monto;
		this.ctaporcobrar.Observacion=Observacion;
		this.ctaporcobrar.TipoCobro=TipoCobro;
        this.FechaRealCobro=FechaRealCobro;
		// console.log(this.ctaporcobrar.Factura);
        //this.IdContrato=IdContra;
        this.NumContrato=NumContra;
        this.poBtnSave.disableBtn=false;  
        // this.bus.$off('Save');
        // this.bus.$on('Save',()=>
        // {
        //   this.Cobrado();
        // });

       

        if (Id>0)
        {
            this.ctaporcobrar.IdCtaCobrar=Id;
			this.Recuperar();
            // this.get_one();
           
        }
            this.bus.$emit('Desbloqueo',false);
       

      });
     

    },
}
</script>
